<template>
  <Authenticated>
    <div class="container">

      <section class="section carts-section">
        <div class="section-header">
          <h2>Live Carts</h2>
          <span class="cart-count-badge" v-if="liveCarts.length">{{ liveCarts.length }}</span>
          <button class="refresh-btn" @click.stop.prevent="fetchLiveCarts" :class="{ spinning: cartsLoading }" title="Refresh">
            <font-awesome-icon icon="sync-alt" />
          </button>
          <button v-if="liveCarts.length" class="clear-all-btn" @click.stop.prevent="clearAllCarts" title="Clear all carts">
            <font-awesome-icon icon="times" /> Clear all
          </button>
        </div>
        <p v-if="!liveCarts.length && !cartsLoading" class="empty-state">No active carts right now.</p>
        <div v-if="cartsLoading" class="loading-carts">Loading...</div>
        <ul class="live-carts" v-if="liveCarts.length">
          <li v-for="cart in liveCarts" :key="cart.cart_id" class="cart-card">
            <div class="cart-card-header">
              <span class="user-id">
                <font-awesome-icon icon="user" />
                {{ cart.cart_id.slice(0, 8) }}&hellip;
              </span>
              <span v-if="cart.site" class="cart-site">{{ cart.site }}</span>
              <span class="cart-total">{{ formatTotal(cart.items) }}</span>
              <button class="clear-cart-btn" @click.stop.prevent="clearCart(cart)" title="Clear this cart">
                <font-awesome-icon icon="times" />
              </button>
            </div>
            <ul class="cart-items">
              <li v-for="item in cart.items" :key="item._id" class="cart-item">
                <div class="item-main">
                  <span class="item-name">{{ item.name || item.id }}</span>
                  <span class="item-qty">× {{ item.quantity }}</span>
                  <span class="item-price">${{ (item.price * item.quantity).toFixed(2) }}</span>
                </div>
                <ul v-if="itemModifiers(item).length" class="item-modifiers">
                  <li v-for="mod in itemModifiers(item)" :key="mod" class="modifier-pill">{{ mod }}</li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </section>

      <section class="section">
        <h2>Websites</h2>
        <div class="create-website">
          <h3>Create new Website</h3>
          <select name="site" id="" v-model="site">
            <option value="" selected>select a site</option>
            <option v-for="site in sites" :key="site.site">{{ site.site }}</option>
          </select>
          <!-- <Carousel :items="getSiteOptions()" title="Select a Site" @select-item="chooseSite" /> -->
          <span>sites.beamy.nz/web/<input type="text" v-model="websiteName" placeholder="Select site or create your own" /></span>
          <button @click.stop.prevent="createNewSite">Create new website</button>
        </div>
        <ul class="websites">
          <li v-for="site in websites" :key="site">
            <div class="column">
              <p>Location - {{ site.site }}</p>
              <a :href="'https://sites.beamy.nz/web/' + site.hash" target="_blank">https://sites.beamy.nz/web/{{ site.hash }}</a>
            </div>
            <div class="icons">
              <router-link :to="`/web/${site.site}`"><font-awesome-icon icon="fa-solid fa-wrench" class="wrench-icon" size="xl" /></router-link>
              <font-awesome-icon icon="fa-solid fa-trash" class="bin-icon" size="xl" @click.stop.prevent="removeSite(site)" />
            </div>
          </li>
        </ul>
      </section>
      <section class="section">
        <h2>Customers</h2>
        <button class="sortBy" @click.stop.prevent="changeSortBy">
          <i>Sort By {{ listOrder }}</i>
        </button>
        <div class="pag-btns">
          <button @click.stop.prevent="getUserOrders(pagCounter(false))">-</button>

          <button @click.stop.prevent="getUserOrders(pagCounter(true))">+</button>
        </div>
        <ul class="users">
          <li v-for="user in users" :key="user.id" @click.stop.prevent="showUserDetails(user)">
            <h3>{{ user.value.fname }} {{ user.value.lname }}</h3>
            <p>No. orders: {{ user.key }}</p>
          </li>
        </ul>
        <UserOrderModal :open="open" :user="user" @close-modal="closeModal" />
      </section>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "../_layouts/Authenticated.vue";
import { mapGetters } from "vuex";
import { api } from "@monolith/helpers";
import UserOrderModal from "./UserOrderModal.vue";
// import Carousel from "../_layouts/Carousel.vue";

export default {
  name: "WebPage",

  components: {
    Authenticated,
    UserOrderModal,
    // Carousel,
  },
  data() {
    return {
      listOrder: "descending",
      users: [],
      sortBy: true,
      currentPag: 0,
      user: {},
      open: false,
      site: "",
      websiteName: null,
      liveCarts: [],
      cartsLoading: false,
      cartUpdateRef: null,
    };
  },
  computed: {
    ...mapGetters({
      channels: "channels",
      companyName: "companyName",
      websites: "websites",
      sites: "siteMap",
      companySettings: "companySettings",
      siteSettings: "siteSettings",
    }),
    // webChannels() {
    //   let topics = [];
    //   this.channels.map((chan) => (chan.topic.split(":")[0] == "web") ? topics.push(chan.topic) : false);
    //   return topics;
    // },
  },
  mounted() {
    this.getUserOrders(0);
    this.fetchLiveCarts();
    this.cartUpdateRef = this.channel.on("cart:updated", this.handleCartUpdate);
  },

  beforeUnmount() {
    this.channel.off("cart:updated", this.cartUpdateRef);
  },

  methods: {
    clearCart(cart) {
      this.channel.push("cart:clear_one", { cart_id: cart.cart_id, site: cart.site || "" }).receive("ok", () => {
        const idx = this.liveCarts.findIndex((c) => c.cart_id === cart.cart_id);
        if (idx !== -1) this.liveCarts.splice(idx, 1);
      });
    },

    clearAllCarts() {
      this.channel.push("cart:clear_all", {}).receive("ok", () => {
        this.liveCarts = [];
      });
    },

    fetchLiveCarts() {
      this.cartsLoading = true;
      this.channel.push("cart:list_all", {}).receive("ok", (reply) => {
        this.liveCarts = reply.carts;
        this.cartsLoading = false;
      });
    },

    handleCartUpdate({ cart_id, items, site }) {
      const idx = this.liveCarts.findIndex((c) => c.cart_id === cart_id);
      if (items.length === 0) {
        if (idx !== -1) this.liveCarts.splice(idx, 1);
      } else if (idx !== -1) {
        this.liveCarts[idx] = { cart_id, items, site };
      } else {
        this.liveCarts.push({ cart_id, items, site });
      }
    },

    itemModifiers(item) {
      if (!item.modifiers || typeof item.modifiers !== "object") return [];
      return Object.values(item.modifiers)
        .flat()
        .map((m) => m.name)
        .filter(Boolean);
    },

    formatTotal(items) {
      const total = items.reduce((sum, i) => sum + i.price * i.quantity, 0);
      return "$" + total.toFixed(2);
    },

    chooseSite(site) {
      this.site = site;
    },

    getSiteOptions() {
      return this.sites.map((site) => {
        return { value: site.site, name: site.site, selected: site.site == this.site };
      });
    },

    createNewSite() {
      let sites = this.websites;
      sites.push({
        site: this.site,
        hash: this.websiteName,
      });
      this.$store.dispatch("setWebsites", sites);
    },

    removeSite(site) {
      let websites = this.websites.filter((s) => s.hash != site.hash);
      this.$store.dispatch("setWebsites", websites);
    },

    changeSortBy() {
      this.sortBy = !this.sortBy;
      this.getUserOrders(0);
      this.listOrder = this.sortBy ? "descending" : "ascending";
    },

    closeModal() {
      this.open = false;
    },

    showUserDetails(user) {
      this.user = user;
      this.open = true;
    },

    pagCounter(next) {
      if (next) {
        this.currentPag += 10;
      } else {
        this.currentPag -= 10;
      }
      return this.currentPag;
    },

    async getUserOrders(pagination) {
      let result = await api.get_enduser_orders(this.sortBy, 10, pagination);
      this.users = result.rows;
    },
  },

  watch: {
    site: {
      handler() {
        this.websiteName = this.companyName + "-" + this.site;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  margin: 1.5rem;
}
h2,
h3 {
  margin-left: 0;
}

.container {
  display: flex;
  align-items: flex-start;
  margin: 0.5rem 1rem;

  .section {
    margin: 0.5rem 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    padding: 0.5rem;
    border-radius: 10px;
    background: var(--primary-colour);
    box-shadow: var(--box-shadow);
    .create-website {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0.5rem;
      padding: 1rem;
      border-radius: 10px;
      background-color: var(--tertiary-colour);
      box-shadow: var(--box-shadow);
      select {
        width: 100%;
        margin: 0.5rem;
        padding: 0.5rem;
        border-radius: 5px;
        border: none;
        color: var(--text-colour);
        background-color: var(--primary-colour);
        box-shadow: var(--box-shadow);
      }
      span {
        margin: 0.5rem;
        padding: 0.5rem;
        border-radius: 5px;
        border: none;
        text-wrap: auto;
        color: var(--action-colour);
        font-size: large;
        margin: 0;
        input {
          width: 15rem;
          margin: 0.5rem;
          padding: 0.5rem;
          border-radius: 5px;
          border: none;
          color: var(--text-colour);
          background-color: var(--primary-colour);
          box-shadow: var(--box-shadow);
        }
      }
      button {
        width: 100%;
        margin: 0.5rem;
        padding: 0.5rem;
        background-color: var(--action-colour);
        color: var(--secondary-text-colour);
        border-radius: 5px;
        border: none;
        box-shadow: var(--box-shadow);
        cursor: pointer;
        &:active {
          box-shadow: none;
        }
      }
    }
    .websites {
      padding-left: 0;
      justify-content: space-around;
      li {
        display: flex;
        align-items: center;
        // justify-content: center;
        list-style: none;
        margin: 0.5rem;
        background-color: var(--tertiary-colour);
        box-shadow: var(--box-shadow);
        padding: 1rem;
        border-radius: 10px;
        .icons {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-left: auto;
          padding: 0.5rem;
        }
        .bin-icon {
          color: var(--warning-colour);
          padding: 0.5rem;
          cursor: pointer;
        }
        .wrench-icon {
          color: var(--action-colour);
          padding: 0.5rem;
          cursor: pointer;
        }
        .column {
          display: flex;
          flex-direction: column;
          p,
          a {
            margin: 0.5rem;
          }
          a {
            color: var(--action-colour);
            cursor: pointer;
          }
        }
      }
    }
    .pag-btns {
      button {
        max-width: 5rem;
        min-width: 3rem;
        background-color: var(--action-colour);
        color: var(--secondary-text-colour);
        text-transform: capitalize;
        border-radius: 10px;
        font-size: 1.5rem;
        border: none;
        i {
          width: 100%;
          margin: 0.25rem;
          font-size: 0.75rem;
        }
      }
    }
    .users {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-evenly;
      padding: 0.25rem;
      li {
        width: 15rem;
        list-style: none;
        margin: 0.5rem;
        padding: 1rem;
        background-color: var(--tertiary-colour);
        box-shadow: var(--box-shadow);
        border-radius: 10px;
        cursor: pointer;
        p {
          margin: 0.5rem;
        }
        h3 {
          margin: 0.5rem;
          color: var(--action-colour);
        }
      }
    }
  }
}

.carts-section {
  min-width: 22rem;
  max-width: 30rem;
  min-height: unset !important;
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  margin-bottom: 0.75rem;
  flex-wrap: nowrap;

  h2 { margin: 0; flex: 1; white-space: nowrap; }
}

.cart-count-badge {
  background-color: var(--action-colour);
  color: var(--secondary-text-colour);
  border-radius: 999px;
  padding: 0.1rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 700;
  flex-shrink: 0;
}

.refresh-btn {
  background: none;
  border: none;
  box-shadow: none;
  color: var(--action-colour);
  cursor: pointer;
  padding: 0.25rem;
  font-size: 1rem;
  margin: 0;
  flex-shrink: 0;
  &.spinning svg { animation: spin 0.8s linear infinite; }
}

.clear-all-btn {
  background: none;
  border: 1px solid var(--warning-colour);
  box-shadow: none;
  color: var(--warning-colour);
  cursor: pointer;
  padding: 0.2rem 0.6rem;
  font-size: 0.8rem;
  border-radius: 0.4rem;
  margin: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  &:hover { background: rgba(244, 67, 54, 0.08); }
}

.clear-cart-btn {
  background: none;
  border: none;
  box-shadow: none;
  color: var(--text-colour);
  opacity: 0.4;
  cursor: pointer;
  padding: 0.1rem 0.3rem;
  font-size: 0.8rem;
  margin: 0;
  line-height: 1;
  &:hover { opacity: 1; color: var(--warning-colour); }
}

@keyframes spin { to { transform: rotate(360deg); } }

.empty-state {
  color: var(--text-colour);
  opacity: 0.5;
  margin-top: 2rem;
}

.loading-carts {
  color: var(--text-colour);
  opacity: 0.6;
  margin-top: 1rem;
}

.live-carts {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 75vh;
  overflow-y: auto;
}

.cart-card {
  background-color: var(--tertiary-colour);
  border-radius: 0.5rem;
  box-shadow: var(--box-shadow);
  padding: 0.75rem 1rem;
  width: 100%;
  box-sizing: border-box;

  .cart-card-header {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    flex-wrap: wrap;
    margin-bottom: 0.6rem;
  }

  .user-id {
    font-size: 0.8rem;
    color: var(--text-colour);
    opacity: 0.6;
    display: flex;
    align-items: center;
    gap: 0.3rem;
    flex-shrink: 0;
  }

  .cart-site {
    font-size: 0.72rem;
    background-color: var(--action-colour);
    color: var(--secondary-text-colour);
    border-radius: 999px;
    padding: 0.1rem 0.5rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    flex-shrink: 0;
  }

  .cart-total {
    font-weight: 700;
    color: var(--action-colour);
    font-size: 1rem;
    margin-left: auto;
  }

  .cart-items {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .cart-item {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .item-main {
    display: flex;
    align-items: baseline;
    gap: 0.5rem;
    font-size: 0.9rem;
    color: var(--text-colour);
    min-width: 0;

    .item-name {
      flex: 1;
      min-width: 0;
      word-break: break-word;
      font-weight: 500;
    }
    .item-qty {
      flex-shrink: 0;
      color: var(--text-colour);
      opacity: 0.6;
      font-size: 0.85rem;
    }
    .item-price {
      flex-shrink: 0;
      font-weight: 600;
      color: var(--action-colour);
    }
  }

  .item-modifiers {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.3rem;
  }

  .modifier-pill {
    font-size: 0.72rem;
    background-color: var(--secondary-colour);
    color: var(--text-colour);
    border-radius: 999px;
    padding: 0.1rem 0.5rem;
    white-space: nowrap;
  }
}

.sortBy {
  border: none;
  margin-bottom: 0.5rem;
}

@media (orientation: portrait) {
  .container {
    margin: 1rem;
    flex-direction: column;
    max-width: 100% !important;
    width: 98% !important;
    .section {
      max-width: 90% !important;
      min-width: 90% !important;
      align-items: center;
      border-radius: 0.5rem;
      margin: 1rem 0;
      h2 {
        margin: 1rem 0;
        text-align: center;
      }
      .create-website {
        max-width: 90%;
        margin: 0 1.5rem 0 1.5rem;
        padding: 1rem;
      }
      .websites {
        max-width: 100%;
        li {
          margin: 1rem auto ;
          flex-direction: column-reverse;
          width: 80%;
          .column {
            margin-top: -2.8rem;
          }
          .icons{
            z-index: 110;
          }
        }
      }
    }
  }
}
</style>
